var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('a',{attrs:{"href":_vm.link}},[_c(_vm.icon,{tag:"component",attrs:{"classes":_vm.classes}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }